import { ChangeDetectionStrategy, Component, Renderer2 } from '@angular/core';
import { ToastEnum } from '../../enums/toast.enum';

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomToastComponent {
  public toastEnum = ToastEnum;

  constructor(private _renderer: Renderer2) {}

  public onConfirm(message, event) {
    window.location.href = message.data.downloadUrl;
    this.removeElement(event.target.closest('p-toastitem'));
  }

  public onReject(event) {
    this.removeElement(event.target.closest('p-toastitem'));
  }

  private removeElement(el): void {
    this._renderer.removeChild(this._renderer.parentNode(el), el);
  }
}
